var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path10, _rect3, _ellipse, _ellipse2, _ellipse3, _path11, _path12, _path13, _ellipse4, _ellipse5, _path14, _path15, _path16, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _ellipse6, _ellipse7, _ellipse8, _rect4, _rect5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse9, _ellipse10, _ellipse11, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDwarfAnvil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 29.586 24.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -5.827 -12.568)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cc5f1e",
    d: "M57.633 78.853C56.598 86.67 46.659 111.891 45.9 116.24c-.773 4.126 1.249 11.394 7.598 9.742-1.423 2.33.601 9.597 7.369 7.47-.325.579-.445 1.286-.395 2.026h56.942c.76-1.112 1.326-2.325 1.617-3.422 1.074-4.324 1.89-32.113 4.16-39.513l-3.27.025s-.76 10.757-3.115 13.234c-2.262 2.517-5 4.616-5 4.616L61.568 99.533s-1.758-3.027-2.767-6.28c-1.142-3.2 2.617-13.337 2.617-13.337Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.8,
    height: 29.9,
    x: -138.013,
    y: 58.712,
    fill: "#f5cfba",
    paintOrder: "markers fill stroke",
    ry: 1.2,
    transform: "scale(-1 1) rotate(-12.188)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    d: "M49.886 121.95 33.608 105.27l2.734-6.445 13.396 4.271Z",
    paintOrder: "stroke fill markers"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7729",
    d: "M56.558 78.187c-1.034 7.817-10.973 33.038-11.732 37.387-.773 4.126 1.248 11.394 7.598 9.742-1.423 2.33.601 9.596 7.277 7.432-.426.758-.496 1.74-.281 2.73h56.394c1.002-1.286 1.73-2.79 2.051-4.127 1.074-4.324 2.522-31.3 4.832-38.793l-3.85-.656s-.853 10.718-3.115 13.234c-2.354 2.478-5.092 4.576-5.092 4.576L60.402 98.828s-1.666-2.988-2.768-6.28c-1.048-3.16 2.618-13.338 2.618-13.338z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aab8ca",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.378,
    d: "m70.826 136.079 8.956 1.053",
    paintOrder: "fill markers stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b0000",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m50.114 109.12-2.323 7.27m3.361.014-1.506 4.576m2.664-18.315 1.922-5.81",
    paintOrder: "stroke fill markers"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.897,
    height: 17.829,
    x: 117.481,
    y: 63.402,
    fill: "#d46354",
    paintOrder: "fill markers stroke",
    ry: 4.695,
    transform: "rotate(18.597)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce4c3a",
    d: "m88.61 105.036 11.312 3.687.54-1.607z",
    paintOrder: "fill markers stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d46354",
    stroke: "#b2473a",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.756,
    d: "m95.397 105-2.089 5.808",
    paintOrder: "fill markers stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ac3f00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 8,
    d: "M109.314 117.832a12 12 0 0 0-9.1-14.398l-25.889-5.55a12 12 0 0 0-14.213 9.178",
    paintOrder: "stroke fill markers"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dc5100",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 8,
    d: "M108.354 117.533a12 12 0 0 0-9.231-14.344l-25.796-5.512a12 12 0 0 0-14.213 9.178",
    paintOrder: "stroke fill markers"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M72.002 106.882s4.464 1.808 8.724 3.289m-32.517 9.33-15.603-15.2",
    paintOrder: "stroke fill markers"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.059,
    height: 52.742,
    x: -3.206,
    y: 126.334,
    fill: "#803f0f",
    paintOrder: "markers fill stroke",
    rx: 0,
    ry: 1.101,
    transform: "matrix(-1.2447 .08018 -.038 1.2467 38.429 -102.543)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.717,
    cy: 57.958,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(-.27633 .96106 .9226 .38574 0 0)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.317,
    cy: 57.858,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(-.27633 .96106 .9226 .38574 0 0)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.369,
    cy: 0.375,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.7,
    paintOrder: "stroke fill markers",
    rx: 1.7,
    ry: 2.4,
    transform: "matrix(.29397 .95581 .9815 -.19143 0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m51.434 103.706-11.898-3.961s-1.588-6.757-4.4-3.713c-5.964 6.377 1.736 11.273 1.669 3.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M120.787 106.405 52.226 94.157l1.13-3.431 66.173 12.756Z",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.2,
    cy: 122.096,
    fill: "#fff",
    fillOpacity: 0.3,
    paintOrder: "markers fill stroke",
    rx: 0.953,
    ry: 1.874,
    style: {
      fontVariationSettings: "normal"
    },
    transform: "matrix(-.26234 .96498 .99507 .09913 0 0)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b0000",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m58.046 127.041-1.364 3.984",
    paintOrder: "stroke fill markers"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -113.5,
    cy: -98.168,
    fill: "#efe5c8",
    rx: 5.6,
    ry: 8.8,
    transform: "scale(-1 1) rotate(-74.288)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -14.831,
    cy: 88.254,
    fill: "#efe5c8",
    rx: 5.6,
    ry: 8.8,
    transform: "rotate(-49.912)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "M122.199 104.614a36.2 36.2 0 0 0-27.3-43.191 36.2 36.2 0 0 0-42.743 28.034"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#dee4ef",
    d: "m90.327 85.77 5.18-23.22c.54-2.812 1.894-2.673 3.76-2.207.999.206 1.255 2.162 1.18 3.108l-4.084 21.405c10.291 2.627 18.775 6.443 27.336 10.075.92.39 1.055 1.1.848 2.098l-1.743 7.95"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1c0d3",
    d: "M98.268 60.137c.999.206 1.501 1.07 1.295 2.07L95.26 85.147a184.7 184.7 0 0 1 27.44 9.577c.92.39 1.553 1.202 1.255 2.162l-1.651 7.99c-.207.998-1.15 1.684-2.11 1.386-23.148-6.887-46.17-11.766-69.32-15.069-1.037-.114-1.592-1.11-1.294-2.07l1.651-7.989c.207-.999 1.164-1.462 2.11-1.386a178.3 178.3 0 0 1 31.511 3.048l5.484-22.658c.207-.998 1.071-1.5 2.07-1.294z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -136.983,
    cy: 72.558,
    r: 2,
    fill: "#768599",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -137.283,
    cy: 72.158,
    r: 2,
    fill: "#b1c0d3",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -137.583,
    cy: 71.658,
    r: 0.6,
    fill: "#ced7e4",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -105.183,
    cy: 70.358,
    r: 2,
    fill: "#768599",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -105.583,
    cy: 70.058,
    r: 2,
    fill: "#b1c0d3",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -105.783,
    cy: 69.558,
    r: 0.6,
    fill: "#ced7e4",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: -121.083,
    cy: 70.958,
    r: 2,
    fill: "#768599",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: -121.483,
    cy: 70.558,
    r: 2,
    fill: "#b1c0d3",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: -121.683,
    cy: 70.158,
    r: 0.6,
    fill: "#ced7e4",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: -89.283,
    cy: 70.958,
    r: 2,
    fill: "#768599",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: -89.683,
    cy: 70.558,
    r: 2,
    fill: "#b1c0d3",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: -89.883,
    cy: 70.158,
    r: 0.6,
    fill: "#ced7e4",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: -73.483,
    cy: 72.558,
    r: 2,
    fill: "#768599",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: -73.783,
    cy: 72.158,
    r: 2,
    fill: "#b1c0d3",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: -74.083,
    cy: 71.658,
    r: 0.6,
    fill: "#ced7e4",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: -105.183,
    cy: 56.158,
    r: 2,
    fill: "#768599",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: -105.583,
    cy: 55.758,
    r: 2,
    fill: "#b1c0d3",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: -105.783,
    cy: 55.258,
    r: 0.6,
    fill: "#ced7e4",
    transform: "scale(-1 1) rotate(-12.188)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -105.183,
    cy: 43.858,
    fill: "#768599",
    rx: 2,
    ry: 1.4,
    transform: "scale(-1 1) rotate(-12.188)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -105.583,
    cy: 43.558,
    fill: "#b1c0d3",
    rx: 2,
    ry: 1.4,
    transform: "scale(-1 1) rotate(-12.188)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -105.783,
    cy: 43.258,
    fill: "#ced7e4",
    rx: 0.6,
    ry: 0.4,
    transform: "scale(-1 1) rotate(-12.188)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.4,
    height: 18,
    x: -93.372,
    y: 106.63,
    fill: "#c4d0e1",
    ry: 2.7,
    transform: "scale(-1 1) rotate(17.012)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5.4,
    height: 18,
    x: -97.111,
    y: -21.258,
    fill: "#c4d0e1",
    ry: 2.7,
    transform: "rotate(-138.512)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e0e6ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    d: "M104.414 67.415c1.841.78 3.632 2.192 5.306 3.88m1.107 1.23c.712.628.765.759 1.398 1.57",
    paintOrder: "markers fill stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    d: "M132.023 80.43s-.77-2.281-4.787-2.03",
    paintOrder: "markers fill stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7729",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M110.072 109.898s1.23 2.477 1.122 5.038m-1.454 4.706c.996-.555 1.217-1.33 1.345-2.145",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    stroke: "#5c6b84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "m79.899 70.919-4.204 2.996",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7729",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M108.736 110.743s1.294 2.07 1.121 5.038",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    stroke: "#5c6b84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "m76.718 70.221.924 4.737",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    stroke: "#ff955a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m115.214 122.616-.304 6.606m-2.642-.687-.678 4.927m-63.565-31.963-1.09 3.34m-1-3.791-.803 2.918m-.854-3.621-.91 2.655",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4d0e1",
    d: "m22.942 49.239-.919 15.034 6.507 1.642L30.323 47.5z",
    paintOrder: "fill markers stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "m30.323 47.5 18.61 6.982-1.685 11.445-18.718-.012Z",
    paintOrder: "fill markers stroke"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    d: "M112.679 136.642c-.1.823-22.189-2.441-22.189-2.441l-1.704-6.79 13.262-4.669s11.717 12.945 10.63 13.9z",
    paintOrder: "stroke fill markers"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aab8ca",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.378,
    d: "m85.753 137.801 8.956 1.054",
    paintOrder: "fill markers stroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m110.72 136.752-21.612-2.72",
    paintOrder: "stroke fill markers"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aab8ca",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.378,
    d: "m94.907 137.966-8.956 1.054M79.98 136.243l-8.956 1.054",
    paintOrder: "fill markers stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#48565e",
    d: "M89.767 137.501q.043.238-.41.464-.453.225-1.152.314-.698.089-1.212-.014-.513-.103-.557-.34-.042-.229.413-.446.453-.225 1.152-.314.698-.089 1.212.014.512.094.554.322zm-7.728-.021q-2.283.29-4.032.194-1.776-.092-2.817-.52-1.042-.438-1.173-1.15-.17-.923 1.038-1.684 1.205-.77 3.507-1.258l.164.895q-1.32.298-2.03.772-.711.464-.61 1.012.13.712 1.661.966 1.504.258 4.136-.077 2.66-.337 4.03-.96 1.37-.622 1.238-1.334-.1-.548-.92-.818-.819-.27-2.24-.23l-.165-.894q2.293-.086 3.774.343 1.453.432 1.62 1.336.13.712-.708 1.389-.839.667-2.5 1.196-1.663.528-3.973.822zm6.219-8.642q.13.703-.705 1.398-.836.685-2.495 1.232-1.687.541-3.97.831-2.256.287-4.036.176-1.808-.116-2.827-.575-1.045-.456-1.176-1.168-.13-.713.703-1.407.808-.692 2.467-1.239 1.657-.556 3.94-.846 2.283-.29 4.092-.164 1.781.12 2.829.584 1.047.465 1.178 1.178zm-2.149.273q-.082-.448-.772-.762-.69-.314-1.969-.395-1.28-.09-3.053.136-1.773.225-2.965.619t-1.712.853q-.548.462-.466.91.084.456.772.76.66.3 1.938.372 1.277.071 3.05-.154 1.8-.228 2.995-.605 1.193-.385 1.742-.838.522-.449.44-.896zm-14.791-7.657q-.108-.584.534-1.133.614-.545 1.989-.99 1.375-.446 3.416-.705l8.676-1.102.15.822-8.326 1.057q-2.202.28-3.288.8-1.115.516-1 1.146.12.649 1.426.875 1.279.23 3.589-.063l8.111-1.03.151.822-8.326 1.057q-2.203.28-3.289.8-1.115.516-.999 1.146.12.649 1.425.875 1.28.23 3.59-.063l8.11-1.03.153.831-14.719 1.869-.152-.831 2.122-.27q-1.2-.1-1.894-.432-.695-.341-.787-.844-.116-.63.628-1.22t2.312-1.031q-1.597-.013-2.545-.387-.948-.375-1.057-.969z",
    "aria-label": ".com",
    fontFamily: "poppins",
    fontSize: 151.181,
    letterSpacing: -6,
    paintOrder: "fill markers stroke",
    style: {
      lineHeight: 0.8,
      InkscapeFontSpecification: "poppins",
      textAlign: "end"
    },
    textAnchor: "end"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "M89.404 138.028q.044.238-.41.463-.453.226-1.15.315-.7.089-1.213-.014-.514-.103-.557-.34-.042-.23.413-.446.453-.226 1.152-.314.698-.089 1.212.014.511.094.553.322zm-7.727-.021q-2.283.29-4.032.194-1.776-.092-2.817-.52-1.042-.439-1.173-1.15-.17-.923 1.038-1.684 1.205-.77 3.507-1.258l.164.895q-1.32.298-2.03.772-.712.464-.61 1.012.13.712 1.66.966 1.505.258 4.137-.077 2.66-.337 4.029-.96 1.37-.622 1.24-1.335-.102-.547-.92-.817-.82-.27-2.242-.23l-.164-.895q2.293-.085 3.774.344 1.453.432 1.62 1.336.13.712-.708 1.389-.84.667-2.501 1.196-1.662.528-3.972.822zm6.219-8.642q.129.703-.706 1.397-.836.686-2.494 1.233-1.687.541-3.97.831-2.257.287-4.036.176-1.808-.116-2.827-.575-1.045-.456-1.176-1.169-.131-.712.703-1.407.808-.69 2.466-1.238 1.657-.556 3.94-.846 2.284-.29 4.093-.164 1.781.12 2.829.584 1.047.465 1.178 1.178zm-2.149.272q-.082-.447-.772-.761-.69-.314-1.969-.395-1.28-.09-3.054.135-1.772.225-2.964.62-1.192.394-1.713.853-.547.462-.465.91.084.456.772.76.66.3 1.937.372 1.278.071 3.05-.154 1.8-.229 2.995-.605 1.194-.385 1.743-.838.522-.45.44-.897zm-14.792-7.656q-.107-.584.534-1.133.615-.545 1.99-.99 1.375-.446 3.416-.706l8.676-1.101.15.822-8.326 1.057q-2.202.28-3.289.8-1.114.516-.999 1.146.12.648 1.426.875 1.279.23 3.589-.063l8.111-1.03.151.822-8.326 1.057q-2.203.28-3.29.8-1.114.516-.998 1.146.119.649 1.425.875 1.28.23 3.589-.063l8.111-1.03.153.83-14.719 1.87-.152-.831 2.121-.27q-1.2-.1-1.893-.432-.695-.342-.787-.844-.116-.63.628-1.22t2.312-1.031q-1.597-.013-2.545-.387-.949-.375-1.058-.969z",
    "aria-label": ".com",
    fontFamily: "poppins",
    fontSize: 151.181,
    letterSpacing: -6,
    paintOrder: "fill markers stroke",
    style: {
      lineHeight: 0.8,
      InkscapeFontSpecification: "poppins",
      textAlign: "end"
    },
    textAnchor: "end"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aab8ca",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.378,
    d: "m69.613 138.919 8.956 1.053M78.767 139.083l-8.956 1.054",
    paintOrder: "fill markers stroke"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.501,
    cy: 32.682,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(.35898 .93334 .96863 -.24851 0 0)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.101,
    cy: 32.582,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(.35898 .93334 .96863 -.24851 0 0)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.845,
    cy: -56.969,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.7,
    paintOrder: "stroke fill markers",
    rx: 1.7,
    ry: 2.4,
    transform: "matrix(.81081 .58531 .66763 -.7445 0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M91.89 126.22s-5.434-3.642-5.842.482"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    stroke: "#ff955a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m99.72 122.502 1.143 3.321m-3.083-2.422 1.119 2.812m-2.865-2.374.876 2.667",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    d: "m90.943 134.065-4.423.42-4.564-4.47 4.564-3.866 6.845.14z",
    paintOrder: "fill markers stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aab8ca",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.378,
    d: "m90.966 136.125 8.956 1.054M100.12 136.29l-8.956 1.053",
    paintOrder: "fill markers stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwarfAnvil);
export default __webpack_public_path__ + "static/media/dwarf_anvil.e878ddf7e0b5e1f2516476dd1acd12d5.svg";
export { ForwardRef as ReactComponent };